<script lang="ts" setup>
// looping over sections, using dynamic components, in a typed way
import {
  SectionsAllEvents,
  SectionsAllNews,
  SectionsAllStores,
  SectionsAllTrends,
  SectionsBrands,
  SectionsCallToAction,
  SectionsCatalog,
  SectionsCatalogHeader,
  SectionsContent,
  SectionsContentGrid,
  SectionsCustomerCta,
  SectionsFallback,
  SectionsFaq,
  SectionsForm,
  SectionsHappyDeals,
  SectionsHeader,
  SectionsHint,
  SectionsHomepageHero,
  SectionsLatestTrends,
  SectionsMagazine,
  SectionsNewsletterSubscription,
  SectionsProductGroupCatalog,
  SectionsProductGroupDetail,
  SectionsProductGroupOverview,
  SectionsProductSelections,
  SectionsSearch,
  SectionsSplit,
  SectionsSteps,
  SectionsTestimonals,
  SectionsUpcomingEvents,
  SectionsUsp,
  SectionsVideos,
} from "#components";

defineProps<{ sections: any; pageTitle: string; currentPageId: string }>();

function GetComponentName(typename: string) {
  switch (typename) {
    case "AllEventsSectionRecord":
      return SectionsAllEvents;
    case "AllNewsSectionRecord":
      return SectionsAllNews;
    case "AllStoresSectionRecord":
      return SectionsAllStores;
    case "AllTrendsSectionRecord":
      return SectionsAllTrends;
    case "BrandsSectionRecord":
      return SectionsBrands;
    case "CallToActionSectionRecord":
      return SectionsCallToAction;
    case "CatalogHeaderSectionRecord":
      return SectionsCatalogHeader;
    case "CatalogSectionRecord":
      return SectionsCatalog;
    case "ContentSectionRecord":
      return SectionsContent;
    case "ContentGridSectionRecord":
      return SectionsContentGrid;
    case "CustomerCtaSectionRecord":
      return SectionsCustomerCta;
    case "FaqSectionRecord":
      return SectionsFaq;
    case "FormSectionRecord":
      return SectionsForm;
    case "HappyDealsSectionRecord":
      return SectionsHappyDeals;
    case "HeaderSectionRecord":
      return SectionsHeader;
    case "HintSectionRecord":
      return SectionsHint;
    case "HomepageHeroSectionRecord":
      return SectionsHomepageHero;
    case "LatestTrendsSectionRecord":
      return SectionsLatestTrends;
    case "MagazineSectionRecord":
      return SectionsMagazine;
    case "NewsletterSubscriptionSectionRecord":
      return SectionsNewsletterSubscription;
    case "ProductGroupCatalogSectionRecord":
      return SectionsProductGroupCatalog;
    case "ProductGroupDetailSectionRecord":
      return SectionsProductGroupDetail;
    case "ProductGroupOverviewSectionRecord":
      return SectionsProductGroupOverview;
    case "ProductSelectionSectionRecord":
      return SectionsProductSelections;
    case "SearchSectionRecord":
      return SectionsSearch;
    case "SplitSectionRecord":
      return SectionsSplit;
    case "StepsSectionRecord":
      return SectionsSteps;
    case "TestimonialsSectionRecord":
      return SectionsTestimonals;
    case "UpcomingEventsSectionRecord":
      return SectionsUpcomingEvents;
    case "UspSectionRecord":
      return SectionsUsp;
    case "VideoSectionRecord":
      return SectionsVideos;
    default:
      return SectionsFallback;
  }
}
</script>

<template>
  <section v-for="section in sections" :key="section.id" :data-typename="section.__typename">
    <component
      :is="GetComponentName(section.__typename)"
      :data="section"
      :page-title="pageTitle"
      :current-page-id="currentPageId"
    />
  </section>
</template>

<style scoped>

</style>
